<div class="container-fluid row px-0 mx-auto">
  <div class="col-12">
    <p class="fs-md-18 text-center">Resale Market</p>
    <div id="chartdiv" style="width: 100%"></div>
  </div>
</div>
